import styles from '../styles/styles.module.css';
import { Sites } from './Sites';
import { useState } from 'react';
import { IoArrowBackCircle } from 'react-icons/io5';
import { FaPlusCircle } from 'react-icons/fa';
import AddSite from './AddSite';
import { useSelector } from 'react-redux';

const SiteSetup = () => {
  const [addSiteActive, setAddSiteActive] = useState(false);
  const { userType } = useSelector((state: any) => state.user);
  function handleAddClick() {
    setAddSiteActive(!addSiteActive);
  }

  return (
    <div className={styles.sitePageWrapper}>
      <p onClick={handleAddClick} className={styles.addSiteButton}>
        {addSiteActive ? (
          <div className={styles.addSite}>
            <IoArrowBackCircle className={styles.backArrow} />
            <p className={styles.addNewTextBack}>Go Back</p>
          </div>
        ) : userType === 'COMPANY_ADMIN' || userType === 'HYPER_ADMIN' ? (
          <div className={styles.addSite}>
            <FaPlusCircle className={styles.plusSymbol} />
            <p className={styles.addNewText}>Add New Site</p>
          </div>
        ) : null}
      </p>
      {addSiteActive ? (
        <AddSite setAddSiteActive={setAddSiteActive} />
      ) : (
        <Sites setAddSiteActive={setAddSiteActive} />
      )}
    </div>
  );
};

export default SiteSetup;
